export interface Volume {
  numeral: string;
  title: string;
  headline: string;
  description: string;
  extra?: string;
  items: string[];
}

export const volumes: Volume[] = [
  {
    numeral: 'I',
    title: 'WORKFLOW 360™',
    headline: 'Build the foundation of your DVO case workflow.',
    description:
      'A structured system for organizing the information, questions and clinical variables that belong at the beginning of a complex DVO assessment.',
    items: [
      'Initial Workflow Map',
      'Case Intake Framework',
      'Clinical Information Inventory',
      'Assessment Sequence',
      'Clinical Observation Checklist',
      'Key Question Bank',
      'Case Organization Worksheet',
      'Information Gap Tracker',
      'Initial Review Checklist',
      'Case Starting Point Map',
    ],
  },
  {
    numeral: 'II',
    title: 'DVO ASSESSMENT WORKFLOW™',
    headline: 'Turn your DVO assessment into a repeatable sequence.',
    description:
      'A visual workflow for organizing the assessment process before moving into further planning.',
    items: [
      'DVO Assessment Workflow',
      'Assessment Sequence Map',
      'Key Variable Checklist',
      'Clinical Observation Framework',
      'Assessment Questions',
      'Information-Gap Worksheet',
      'Case Assessment Sheet',
      'Review Checkpoints',
      'Assessment Summary',
      'Quick Assessment Reference',
    ],
  },
  {
    numeral: 'III',
    title: 'RECORDS & DOCUMENTATION FLOW™',
    headline: 'Organize the information your workflow needs.',
    description:
      'A practical system for structuring records, measurements, photography and case documentation.',
    items: [
      'Records Workflow',
      'Photography Checklist',
      'Measurement Organization Sheet',
      'Clinical Records Tracker',
      'Documentation Checklist',
      'Case Information Worksheet',
      'Comparison Tables',
      'Missing Records Tracker',
      'Documentation Review',
      'Case Summary Sheet',
    ],
  },
  {
    numeral: 'IV',
    title: 'DECISION WORKFLOW™',
    headline: 'Organize what happens between assessment and planning.',
    description:
      'Because complex cases involve multiple variables, and the sequence in which you review them matters.',
    extra:
      'A visual framework for organizing clinical questions, checkpoints and planning considerations.',
    items: [
      'Decision Workflow Map',
      'Clinical Question Sequence',
      'Decision Checkpoints',
      'Variable Review Matrix',
      'Case Hypothesis Worksheet',
      'Attention Signals',
      'Reassessment Triggers',
      'Decision Review Sheet',
      'Planning Preparation Checklist',
      'Final Decision Review',
    ],
  },
  {
    numeral: 'V',
    title: 'VALIDATION & AUDIT FLOW™',
    headline: 'Build a review checkpoint into your workflow.',
    description:
      'A structured audit process designed to help you review the important elements of your case before moving forward according to your professional judgment.',
    items: [
      'Validation Workflow',
      'Critical Review Checklist',
      'Red Flag Review',
      'Information Gap Audit',
      'Case Completeness Checklist',
      'Risk-Attention Matrix',
      'Common Workflow Errors',
      'Pre-Planning Audit',
      'Case Review Sheet',
      'Final Workflow Audit',
    ],
  },
  {
    numeral: 'VI',
    title: 'COMPLEX CASE WORKFLOW MASTER™',
    headline: 'Bring your entire DVO workflow together.',
    description:
      'The master system that connects assessment, documentation, analysis, decision checkpoints, validation and reassessment into one repeatable workflow.',
    extra: 'Your complete DVO workflow — organized from beginning to final review.',
    items: [
      'Master DVO Workflow',
      'Case Classification',
      'Assessment Workflow',
      'Records Workflow',
      'Decision Workflow',
      'Validation Workflow',
      'Reassessment Workflow',
      'Case Planning Sheet',
      'Workflow Checkpoints',
      'Final Case Review',
      'Master Quick Reference',
    ],
  },
];
